module.exports = __webpack_public_path__ + "static/expandonlinepresence2-ff7befc8a0e9e59dd6ff138329b1226e.svg";